import React from 'react';

const MicSVG = ({ color = '#7E7E7E', className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='22'
      viewBox='0 0 17 22'
      fill='none'
      className={className}
      onClick={onClick}
      {...props}
    >
      <path
        d='M12.839 4.71053C12.839 2.38512 10.9539 0.5 8.6285 0.5C6.30309 0.5 4.41797 2.38512 4.41797 4.71053V9.97368C4.41797 12.2991 6.30309 14.1842 8.6285 14.1842C10.9539 14.1842 12.839 12.2991 12.839 9.97368V4.71053Z'
        fill={color}
      />
      <path
        d='M1.26172 9.97363C1.26172 11.9278 2.03803 13.8021 3.41988 15.1838C4.80173 16.5657 6.67593 17.3421 8.63014 17.3421C10.5844 17.3421 12.4586 16.5657 13.8404 15.1838C15.2222 13.8021 15.9986 11.9278 15.9986 9.97363'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.62891 20.4998V18.3945'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default MicSVG;
